module.exports = __webpack_public_path__ + "dd0127e39a044ae483ec112b183c047a.jpg";